module.exports = __webpack_public_path__ + "img/head-four.42d156a3.png";